import { rootActions, useAppDispatch, useAppSelector } from '../../../data/store';
import { useState } from 'react';
import Preloader from '../../../../../../ui/svg/common/preloader';
import CloseIcon from '../../../../../../ui/svg/common/close';
import { removeUndoCartItem } from '../../../domain/undo-cart-item-provider';
import { IUndoCartItem } from '../../../interfaces';
import { sendGAEvent } from '../../../../../../domain/marketing/gtm-provider';
import { addCartItem } from '../../../data/data-service';
import { getLocalData } from '../../../domain/shopping-cart-address-provider';

const UndoCartItems = () => {

    const dispatch = useAppDispatch();

    const removedItems = useAppSelector(store => store.root.removedItems);
    const[loading, setLoading] = useState(0);

    const remove = (removedItem: IUndoCartItem) => {
        dispatch(
            rootActions.main({
                removedItems: removeUndoCartItem(removedItem) || [],
            })
        );

        sendGAEvent('skuRemoved', 'Close');
    };

    const undo = async (removedItem: IUndoCartItem) => {

        setLoading(removedItem.skuid);

        const response = await addCartItem(
            removedItem.skuid,
            getLocalData()
        );

        setLoading(0);

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        // update cart data ---> now it includes the new product
        dispatch(
            rootActions.setCartData(response.data.relatedData)
        );

        // remove this 'undo' item from the 'undo items list' and from the storage
        dispatch(
            rootActions.main({
                removedItems: removeUndoCartItem(removedItem) || [],
            })
        );

        sendGAEvent('skuRemoved', 'Undo');
    };

    return (
        <>
            {
                removedItems && removedItems.length > 0 && (
                    <div className="w-full">
                        {
                            removedItems.map(removedItem => {
                                return (
                                    <div key={ `removed-item-${ removedItem.skuid }` } className="bg-gray-150 border rounded text-gray-500 flex items-center justify-between mb-4 px-6 py-3">

                                        <div>
                                            <b>{ removedItem.name }</b> has been removed from your cart.
                                        </div>

                                        <div className="flex items-center">

                                            {
                                                (loading !== removedItem.skuid || loading === 0) &&
                                                <>
                                                    <button
                                                        aria-label={ `undo ${ removedItem.name }` }
                                                        type="button"
                                                        className="mr-4 underline"
                                                        onClick={ () => {
                                                            undo(removedItem);
                                                        }}>
                                                        Undo
                                                    </button>

                                                    <button
                                                        type="button"
                                                        data-qa="cart-step1-dismiss-removed-product"
                                                        onClick={ () => {
                                                            remove(removedItem);
                                                        }}>
                                                        <CloseIcon width="12px" />
                                                    </button>
                                                </>
                                            }

                                            {
                                                (loading === removedItem.skuid) &&
                                                <div className="flex justify-center">
                                                    <Preloader width="25px" height="25px" color="#4f4f4f" />
                                                </div>
                                            }

                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }
        </>
    )
};

export default UndoCartItems;